import * as React from "react";
const SvgChevronUpDownIcon = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { fill: "none", "data-icon": "chevronUpDown", role: "img", viewBox: "0 0 12 12", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M3.322 7.344 6 10.016l2.678-2.672.822.823-3.5 3.5-3.5-3.5Zm0-2.688L6 1.984l2.678 2.672.822-.823L6 .333l-3.5 3.5z" }));
export default SvgChevronUpDownIcon;
